import { type ComputedRef, type Ref } from 'vue';

import { ValidExperimentName } from '../types';
import { useActivateExperiment } from './useExperiment';
import { useReadyStore } from '@/helpers/composables/useStores';

interface useActivateSrExperimentProps {
	experimentName: ValidExperimentName;
	/** Activation condition for useActivateExperiment composable */
	activationCondition: Ref<boolean> | ComputedRef<boolean>;
}

/** Composable hook to activate a specific SR experiment and retrieve its state and settings.*/
export function useActivateSrExperiment({ experimentName, activationCondition }: useActivateSrExperimentProps) {
	const { newExperimentsLoaded } = useReadyStore();

	const { activeVariantWithControlGroup, isExperimentActive, experimentInfo } = useActivateExperiment(
		experimentName,
		activationCondition
	);

	return {
		/** Returns the active variant returned by the API isolated from experiment activation (pre experiment) */
		experimentInfo,
		/** The current active variant from experiment activation */
		activeVariantWithControlGroup,
		/** Indicates if all BE experiments have been loaded first */
		newExperimentsLoaded,
		isExperimentActive,
	};
}
